import { render, staticRenderFns } from "./StudentSetting.vue?vue&type=template&id=24098783&scoped=true&lang=pug&"
import script from "./StudentSetting.vue?vue&type=script&lang=ts&"
export * from "./StudentSetting.vue?vue&type=script&lang=ts&"
import style0 from "./StudentSetting.vue?vue&type=style&index=0&id=24098783&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24098783",
  null
  
)

export default component.exports